import React from "react";
import MobileTitleManPowerProData from "./TitleManPowerData";

function MobileManPowerPro({ Data, getData, projectList, projectId ,Role,Type}) {
  

  return (
    <div className=" w-full  h-[70vh] overflow-y-auto">
      {Data &&
        Data.map((item, idx) => {
          return (
            <MobileTitleManPowerProData rowData={item} key={idx} getData={getData} projectList={projectList} projectId={projectId} Role={Role} Type={Type} />
          );
        })}
    </div>
  );
}

export default MobileManPowerPro;
